import { render, staticRenderFns } from "./saticiara.vue?vue&type=template&id=52823ed0&"
import script from "./saticiara.vue?vue&type=script&lang=js&"
export * from "./saticiara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports